import React, { Fragment } from "react"

import BackgroundImage from "../../common/BackgroundImage"
import ShortTextWithReadMore from "../../common/ShortTextWithReadMore"
import ExpandableIcon from "../../common/ExpandableIcon"
import SideRemoveButton from "../../common/SideRemoveButton"
import SideCheckBox from "../../common/SideCheckBox"

const InsightAreaListItem = ({
    id,
    activeId,
    name,
    type,
    mapping_count,
    article_count,
    image_url,
    onClick,
    toggleExpansion,
    isExpanded,
    description,
    subtitle,
    onRemoveClick,
    isChecked,
    showCheckbox = false
}) => (
    <div
        className={`list-group-item${id === activeId ? " active" : ""}`}
        onClick={onClick ? onClick(id) : () => null}
    >
        <BackgroundImage
            classList={["list-group-item-thumb"]}
            imageUrl={image_url}
            isThumbnail={true}
        />
        <div className="list-group-item-content">
            <h4>{name}</h4>
            {type !== undefined && <p>{type || "None"}</p>}
            {mapping_count !== undefined && (
                <p>
                    {mapping_count} Mapping{mapping_count === 1 ? "" : "s"}
                </p>
            )}
            {article_count !== undefined && (
                <p>
                    {article_count} Article{article_count === 1 ? "" : "s"}
                </p>
            )}
            {subtitle && <p>{subtitle}</p>}
            {onRemoveClick && <SideRemoveButton onClick={onRemoveClick(id)} />}
            {showCheckbox && <SideCheckBox isAdded={isChecked} />}
            {toggleExpansion && (
                <Fragment>
                    <ExpandableIcon isExpanded={isExpanded} />
                    <div style={{ marginTop: "5px" }}>
                        <ShortTextWithReadMore
                            text={description}
                            shouldShowMore={isExpanded}
                        />
                    </div>
                </Fragment>
            )}
        </div>
    </div>
)

export default InsightAreaListItem
